import Vue from 'vue'

function is_active(path) {

	var active = false;

	if(Array.isArray(path)) {
		path.forEach(item => {
			if(route().current(item))
				active = true;
		})

		return active;
	}
	
	return route().current(path);
}


function active_link(path, classname) {
	
	var classes = [classname]

	if(Array.isArray(path)) {

		path.forEach(item => {
			if(is_active(item))
				classes.push('text-dark');
		});

	} else {
		if(is_active(path))
			classes.push('text-dark');
	}
	

	return classes
}

Vue.mixin({ 
	methods: { 
		route: window.route ? window.route : () => {},
		
		active_nav: function(path) { 
			return active_link(path, 'text-muted') 
		},

		active_dropdown: function(path) { 
			return active_link(path, 'dropdown-item') 
		},

		is_active: is_active
	}
})